import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

import { GreenhouseOverviewComponent } from './components/greenhouse-overview/greenhouse-overview.component';

@Component({
  selector: 'app-greenhouse',
  templateUrl: './greenhouse.component.html',
  imports: [GreenhouseOverviewComponent],
})
export class GreenhouseComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
